import { NgModule } from '@angular/core';
import { ToastrModule } from 'ngx-toastr';

const TOASTER_TIMEOUT = 4000

@NgModule({
  imports: [
    ToastrModule.forRoot({
      timeOut: TOASTER_TIMEOUT,
      closeButton: false,
      progressBar: false,
      positionClass: 'toast-bottom-center',
      preventDuplicates: true,
      enableHtml: true,
    })
  ],
  exports: [ToastrModule]
})
export class AppToastrModule {}
